<!--
 * @Description: 
 * @Date: 2020-07-21 13:31:05
-->
<template>
  <div class="bi-images" v-if="images && images.length">
    <div v-for="(item, index) in list" :key="index">
      <img :src="item" />
    </div>
  </div>
</template>

<script>
import { getImgBase64 } from '@/tools';
export default {
  props: {
    images: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      list: []
    };
  },
  components: {},
  watch: {
    images: {
      immediate: true,
      handler(v) {
        if (v && v.length) {
          Promise.all(v.map(item => getImgBase64(item))).then(res => {
            this.list = res;
          });
        }
      }
    }
  },
  computed: {},
  methods: {},
  created() {},
  beforeDestroy() {}
};
</script>

<style scoped lang="scss">
.bi-images {
  column-count: 5;
  column-width: 240px;
  column-gap: 20px;
  div {
    break-inside: avoid;
  }
  img {
    background: #fff;
    padding: 4px;
    border-radius: 4px;
    display: block;
    width: 100%;
    // vertical-align: middle;
  }
}
</style>
